export const robots = [
    {
        id: 1,
        name: 'John Smith',
        username: 'jsmith',
        email: 'jsmith@gmail.com'
    },
    {
        id: 2,
        name: 'James Davis',
        username: 'jdavis',
        email: 'jdavis@gmail.com'
    },
    {
        id: 3,
        name: 'Mike Jones',
        username: 'mjones',
        email: 'mjones@gmail.com'
    },
    {
        id: 4,
        name: 'Joe Schmoe',
        username: 'jschmoe',
        email: 'jschmoe@gmail.com'
    },
    {
        id: 5,
        name: 'Don Johnson',
        username: 'djohnson',
        email: 'djohnson@gmail.com'
    },
    {
        id: 6,
        name: 'David Clark',
        username: 'dclark',
        email: 'dclark@gmail.com'
    },
    {
        id: 7,
        name: 'Tom Peterson',
        username: 'tpeterson',
        email: 'tpeterson@gmail.com'
    },
    {
        id: 8,
        name: 'Jason Henry',
        username: 'jhenry',
        email: 'jhenry@gmail.com'
    }
];